import React, { useState, useEffect } from "react";

const CookieSettings = ({ isOpen, onClose }) => {
  const [analyticsCookies, setAnalyticsCookies] = useState(false);

  useEffect(() => {
    const savedSettings = JSON.parse(localStorage.getItem("cookiePreferences")) || {};
    setAnalyticsCookies(savedSettings.analytics || false);
  }, []);

  const savePreferences = () => {
    const preferences = { analytics: analyticsCookies };
    localStorage.setItem("cookiePreferences", JSON.stringify(preferences));
    onClose();
  };

  return isOpen ? (
    <div className="cookie-settings-modal">
      <h3>Cookie Settings</h3>
      <label>
        <input
          type="checkbox"
          checked={analyticsCookies}
          onChange={() => setAnalyticsCookies(!analyticsCookies)}
        />
        Enable Analytics Cookies
      </label>
      <div>
        <button onClick={savePreferences}>Save</button>
        <button onClick={onClose}>Close</button>
      </div>
    </div>
  ) : null;
};

export default CookieSettings;
